'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ecomponents$002e$002dMessage$002dState from "./mealorama.components.-Message-State.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MessageState$() {
}
export { $c_Lmealorama_components_MessageState$ as $c_Lmealorama_components_MessageState$ };
$p = $c_Lmealorama_components_MessageState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MessageState$;
/** @constructor */
function $h_Lmealorama_components_MessageState$() {
}
export { $h_Lmealorama_components_MessageState$ as $h_Lmealorama_components_MessageState$ };
$h_Lmealorama_components_MessageState$.prototype = $p;
$p.aD5 = (function(message) {
  return new $j_mealorama$002ecomponents$002e$002dMessage$002dState.$c_Lmealorama_components_MessageState(false, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(message), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("Error"), "error");
});
$p.aU2 = (function(message) {
  return new $j_mealorama$002ecomponents$002e$002dMessage$002dState.$c_Lmealorama_components_MessageState(false, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(message), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("Info"), "info");
});
var $d_Lmealorama_components_MessageState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MessageState$, "mealorama.components.MessageState$", ({
  Hr: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_components_MessageState$ as $d_Lmealorama_components_MessageState$ };
var $n_Lmealorama_components_MessageState$;
function $m_Lmealorama_components_MessageState$() {
  if ((!$n_Lmealorama_components_MessageState$)) {
    $n_Lmealorama_components_MessageState$ = new $c_Lmealorama_components_MessageState$();
  }
  return $n_Lmealorama_components_MessageState$;
}
export { $m_Lmealorama_components_MessageState$ as $m_Lmealorama_components_MessageState$ };
//# sourceMappingURL=mealorama.components.-Message-State$.js.map
